import React from 'react';
import { FileBox, MCText, View } from '../basic';
import DefaultPdfImg from 'src/assets/images/default-pdf-img.png';
import { lang, remCss } from 'src/helpers';
import LANG_CONST from '../../helpers/lang/const';

const CertificateDetail = ({ item }) => {
  if (!item) return null;

  return (
    <View style={{ flexDirection: 'row', gap: remCss(15), alignItems: 'center' }}>
      <View style={{ height: remCss(70), width: remCss(70) }}>
        <FileBox
          template={1}
          thumbnail={DefaultPdfImg}
          file={{
            ...item,
            name: `${item.title} (${lang.t(LANG_CONST.constants.specialist[item.specialty])} - ${item.promotionYear})`
          }}
          showFileName={false}
          onClose={null}
          styles={{ height: remCss(70), width: remCss(70) }}
        />
      </View>
      <View>
        <MCText label={item.title} size={18} weight={400} textLight />
        <MCText label={LANG_CONST.constants.specialist[item.specialty]} size={18} weight={500} />
        <MCText label={item.promotionYear} size={18} weight={400} />
      </View>
    </View>
  );
};
export default CertificateDetail;
